import { render, staticRenderFns } from "./ImportDressBrand.vue?vue&type=template&id=79e5654f&scoped=true"
import script from "./ImportDressBrand.vue?vue&type=script&lang=js"
export * from "./ImportDressBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e5654f",
  null
  
)

export default component.exports